import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { ArrowUpRight } from 'feather-icons-react';

const discoverDetails = [
  {
    content:
      'Participate in technology-specific assessments and build a standout profile with your scores.'
  },
  {
    content:
      'Get direct visibility to hiring managers and recruiters seeking top talent in cutting-edge technologies.'
  },
  {
    content:
      'Access tailored resources and opportunities to strengthen your technical skills and career readiness.'
  },
  {
    content:
      'Stay ahead of the curve with real-time performance tracking and a leaderboard ranking among your peers.'
  }
];

const DiscoverWhy = () => {
  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column">
        <Card.Title className="fs-5 fw-bold">
          Discover why CRUDBeat is the ultimate platform for students!
        </Card.Title>
        <Row className="w-100 mt-3 mt-md-8">
          <Col lg={5} className="d-flex flex-column mb-4 mb-lg-0">
            <div className="fs-6 fw-bold">
              <div>Empower your career journey</div>
              <div className="text-body-quaternary">
                with unparalleled opportunities!
              </div>
            </div>
          </Col>
          <Col lg={7} className="d-flex">
            <Row className="w-100 gy-4 gy-md-8">
              {discoverDetails.map((details, idx) => (
                <Col xs={12} md={6} key={idx}>
                  <div className="d-flex justify-content-start mb-3 ">
                    <div className="bg-body-highlight p-2 rounded-circle">
                      <ArrowUpRight size={20} className="text-primary-dark" />
                    </div>
                  </div>
                  <div className="fw-semibold">{details.content}</div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default DiscoverWhy;
